<template>
  <div>Clients works !</div>
</template>

<script>
export default {
  name: 'Clients',
}
</script>

<style>

</style>
